import { App, type URLOpenListenerEvent } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'

export default defineNuxtPlugin(async () => {
  if (!Capacitor.isNativePlatform()) {
    return
  }

  const router = useRouter()

  async function navigateToDeepLink(urlString: string) {
    try {
      const url = new URL(urlString)

      // Keeps the Nuxt route, query parameters, and hash.
      const route = `${url.pathname}${url.search}${url.hash}`

      await router.push(route)
    } catch (error) {
      console.error('Could not handle deep link:', urlString, error)
    }
  }

  // Handles a link while the app is already open, as well as most startup
  // cases where Capacitor has registered the listener early enough.
  App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
    void navigateToDeepLink(event.url)
  })

  // Handles a cold launch robustly: the app was not running when the link
  // was tapped.
  const launchUrl = await App.getLaunchUrl()

  if (launchUrl?.url) {
    await router.isReady()
    await navigateToDeepLink(launchUrl.url)
  }
})
